import axios from "axios";
import { BASE_URL } from "../../helper/base-url";
import { applyFeeRules } from "../../utils/liberFees";

export const DEFAULT_FEE_RULES = {
  platformPercent: 10,
  clientServiceFeePercent: 3,
  milestoneHoldDays: 7,
  minWithdrawalAed: 100,
};

let cachedFeeRules = { ...DEFAULT_FEE_RULES };
let inflight = null;

export function getCachedFeeRules() {
  return { ...cachedFeeRules };
}

export function getPlatformFeeRate() {
  const pct = Number(cachedFeeRules.platformPercent);
  if (Number.isFinite(pct) && pct >= 0 && pct <= 100) return pct / 100;
  return DEFAULT_FEE_RULES.platformPercent / 100;
}

export function getPlatformFeePercentLabel() {
  const pct = Number(cachedFeeRules.platformPercent);
  return Number.isFinite(pct) ? String(pct) : String(DEFAULT_FEE_RULES.platformPercent);
}

/**
 * Load fee rules published from Admin → Settings (platform-status).
 * Safe to call often — results are cached in-memory.
 */
export async function fetchFeeRules({ force = false } = {}) {
  if (!force && cachedFeeRules && cachedFeeRules._loaded) {
    return getCachedFeeRules();
  }
  if (!force && inflight) return inflight;

  inflight = (async () => {
    try {
      const res = await axios.get(`${BASE_URL}platform-status`);
      const data = res?.data?.result?.data || res?.data?.data || {};
      const rules = { ...DEFAULT_FEE_RULES, ...(data.feeRules || {}) };
      cachedFeeRules = { ...rules, _loaded: true };
      applyFeeRules(rules);
      return getCachedFeeRules();
    } catch {
      cachedFeeRules = { ...DEFAULT_FEE_RULES, _loaded: true };
      applyFeeRules(cachedFeeRules);
      return getCachedFeeRules();
    } finally {
      inflight = null;
    }
  })();

  return inflight;
}
